module.exports = __webpack_public_path__ + "static/media/support-2.85e1865e.svg";